import React, { useEffect } from 'react';
import { Router, useNavigate, useLocation } from '@reach/router';

import * as Containers from '@agilytics/containers';
import { routes } from '@agilytics/routing';
import { useAnalytics } from '@agilytics/context/Analytics';
import { atlassian } from '@agilytics/utils';
import { useAgilyticsState, useAgilyticsDispatch } from '@agilytics/global-state';

function App() {
  const location = useLocation();
  const dispatch = useAgilyticsDispatch();
  const navigate = useNavigate();
  const { cloudId } = useAgilyticsState();
  const { analytics } = useAnalytics();

  useEffect(() => {
    analytics.page({ search: '' });
  }, [location, analytics]);

  useEffect(() => {
    const checkAccessToken = async () => {
      if ('/'.includes(location.pathname)) {
        return;
      }
      const accessToken = await atlassian.getAccessToken();
      dispatch({ type: 'updateAccessToken', accessToken });
      if (
        !accessToken &&
        routes
          .filter(r => r.requiresAuth)
          .map(r => r.path)
          .includes(location.pathname.toLowerCase()) &&
        !location.pathname.includes('/500')
      ) {
        // login page ...
        return navigate('/consent', { replace: true });
      }

      // no cloud ID, go select which instance ...
      if (
        !cloudId &&
        accessToken &&
        routes
          .filter(r => !r.noRedirect)
          .map(r => r.path)
          .includes(location.pathname.toLowerCase()) &&
        !location.pathname.includes('/select-instance')
      ) {
        navigate('/select-instance', { replace: true });
      }

      // we need a project now ...
      if (
        accessToken &&
        cloudId &&
        ['/select-instance', '/consent', '/jira/callback'].includes(location.pathname.toLowerCase())
      ) {
        navigate(`/projects/${cloudId}`);
      }
    };
    checkAccessToken();
  }, [cloudId, dispatch, location.patchname, location.pathname, navigate]);

  return (
    <>
      <Router>
        {routes.map(routeConfig => {
          const RouteLayout = routeConfig.layout;
          const RouteContainer = Containers[routeConfig.container];
          const { path } = routeConfig;
          if (!RouteContainer) {
            throw new Error(
              `Your route wants to use ${routeConfig.container}, but no such container exists. Make sure it's exported.`
            );
          }

          return (
            <RouteLayout path={path} key={path}>
              <RouteContainer path="/" />

              <Containers.NotFound default />
            </RouteLayout>
          );
        })}
      </Router>
    </>
  );
}

export default App;
